import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InvoicesPage } from '@/features/invoices/components/InvoicesPage';

const searchSchema = z.object({
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/invoices/')({
  component: InvoicesPage,
  validateSearch: searchSchema,
});
